import React, { useState } from "react";
import Header from "../components/header";
import DividerBottom from "../components/divider-bottom";
import Footer from "../components/footer";

function ContactUs() {
  const [subject, setSubject] = useState("");

  const handleSectionChange = (event) => {
    setSubject("New enquiry: " + event.target.value);
  };

  return (
    <>
      <Header />

      <main>
        <section id="contact"> 
          <h1>Contact Us</h1>

          <form
            id="contact-form"
            action="https://formspree.io/f/xnnjvdka"
            method="POST"
          >
            <div className="form-group">
              <label htmlFor="name">Name:</label>
              <input type="text" id="name" name="name" required />
            </div>

            <div className="form-group">
              <label htmlFor="email">Email:</label>
              <input type="email" id="email" name="email" required />
            </div>

            <div className="form-group">
              <label htmlFor="section">Section:</label>
              <select
                id="section"
                name="Section"
                required
                onChange={handleSectionChange}
                defaultValue=""
              >
                <option value="" disabled>
                  Select a section
                </option>
                <option value="Beavers">Beavers</option>
                <option value="Cubs">Cubs</option>
                <option value="Scouts">Scouts</option>
              </select>
            </div>

            <div className="form-group">
              <label htmlFor="message">Message:</label>
              <textarea id="message" name="message" required></textarea>
            </div>

            <input type="hidden" name="subject" id="subject" value={subject} />

            {/* spam protection */}
            <input type="text" name="_gotcha" style={{ display: "none" }} />

            <button type="submit" id="submit">
              <svg
                className="svgIcon"
                viewBox="0 0 512 512"
                height="1.5rem"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path d="M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm50.7-186.9L162.4 380.6c-19.4 7.5-38.5-11.6-31-31l55.5-144.3c3.3-8.5 9.9-15.1 18.4-18.4l144.3-55.5c19.4-7.5 38.5 11.6 31 31L325.1 306.7c-3.2 8.5-9.9 15.1-18.4 18.4zM288 256a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z"></path>
              </svg>
              Submit
            </button>
          </form>
        </section>

        <DividerBottom />
      </main>

      <Footer />
    </>
  );
}

export default ContactUs;